// src/components/HeaderRoutes.jsx

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../authContext';
import rsiIcon from '../medias/rsi.png';
import discordIcon from '../medias/discord.png';

export default function HeaderRoutes() {
  const location = useLocation();
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();

  const isActive = (path) => location.pathname === path ? 'nav-link-active' : '';

  return (
    <>
      <Link className={`nav-link ${isActive('/')}`} to="/">{t('Home')}</Link>
      <Link className={`nav-link ${isActive('/info')}`} to="/info">{t('Info')}</Link>
      <Link className={`nav-link ${isActive('/structure')}`} to="/structure">{t('Structure')}</Link>
      
      <div className="icons">
        <a href="https://robertsspaceindustries.com/orgs/PISC" target="_blank" rel="noopener noreferrer">
          <img src={rsiIcon} alt="RSI" className="header-rsi-icon" />
        </a>
        <a href="https://discord.gg/dXhWQpkM24" target="_blank" rel="noopener noreferrer">
          <img src={discordIcon} alt="Discord" className="header-discord-icon" />
        </a>
        {!isLoggedIn && location.pathname !== '/join' && (
          <div className="button-container">
            <div className="trapezoid-border">
              <Link to="/join" className="trapezoid-button">
                <span className="pulse-text">join us</span>
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
